/* TSC Buylist Admin — storefront-hosted panel talking to the worker /admin/api */
(function () {
  var root = document.getElementById("badmin");
  if (!root) return;
  var W = (root.getAttribute("data-worker") || "").replace(/\/$/, "");
  var $ = function (id) { return document.getElementById(id); };
  var fmt = function (n) { return n == null ? "—" : "$" + Number(n).toFixed(2); };
  var dt = function (ms) { return new Date(ms).toLocaleString(); };
  var esc = function (s) { var d = document.createElement("i"); d.textContent = s == null ? "" : String(s); return d.innerHTML; };
  var TOKEN = sessionStorage.getItem("tsc_admin_token") || "";
  var CUR = null;

  function api(path, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ "Content-Type": "application/json" },
      opts.headers || {}, TOKEN ? { Authorization: "Bearer " + TOKEN } : {});
    return fetch(W + path, opts).then(function (r) {
      if (r.status === 401 && path !== "/admin/api/login") {
        TOKEN = ""; sessionStorage.removeItem("tsc_admin_token");
        $("baApp").hidden = true; $("baLogin").hidden = false;
        throw new Error("Session expired — sign in again.");
      }
      return r.json();
    });
  }

  // ── login ──
  function login() {
    $("baGo").disabled = true;
    api("/admin/api/login", { method: "POST", body: JSON.stringify({ password: $("baPw").value }) })
      .then(function (j) {
        if (j.token) {
          TOKEN = j.token; sessionStorage.setItem("tsc_admin_token", TOKEN);
          boot(j.persistent);
        } else { $("baLoginMsg").textContent = j.error || "Sign-in failed."; }
      })
      .catch(function (e) { $("baLoginMsg").textContent = e.message; })
      .finally(function () { $("baGo").disabled = false; });
  }
  $("baGo").addEventListener("click", login);
  $("baPw").addEventListener("keydown", function (e) { if (e.key === "Enter") login(); });

  function boot(persistent) {
    $("baLogin").hidden = true; $("baApp").hidden = false;
    api("/admin/api/settings").then(function (s) {
      $("baCash").value = s.cashPct; $("baCredit").value = s.creditPct; $("baMin").value = s.minOffer;
    });
    if (persistent === false) $("baPersist").hidden = false;
    loadList();
    loadMessages();
  }

  $("baSave").addEventListener("click", function () {
    api("/admin/api/settings", { method: "POST", body: JSON.stringify({
      cashPct: $("baCash").value, creditPct: $("baCredit").value, minOffer: $("baMin").value,
    })}).then(function (j) {
      $("baSetMsg").textContent = "Saved — customers now see " + j.cashPct + "% cash / " + j.creditPct + "% store credit.";
    });
  });

  // ── list ──
  function loadList() {
    api("/admin/api/submissions").then(function (j) {
      var rows = (j.submissions || []).map(function (s) {
        return '<tr class="rowlink" data-id="' + esc(s.id) + '">' +
          "<td><b>" + esc(s.id) + "</b>" + (s.needsReview ? ' <span class="warn">•</span>' : "") + "</td>" +
          "<td>" + dt(s.createdAt) + "</td>" +
          "<td>" + esc(s.contact.name) + '<div class="mute">' + esc(s.contact.email) + "</div></td>" +
          "<td>" + s.itemCount + "</td>" +
          '<td class="right">' + fmt(s.total) + "</td>" +
          "<td>" + esc(s.payout) + "</td>" +
          '<td><span class="badge b-' + esc(s.status) + '">' + esc(s.status) + "</span></td></tr>";
      }).join("");
      $("baRows").innerHTML = rows || '<tr><td colspan="7" class="mute">No submissions yet.</td></tr>';
      Array.prototype.forEach.call($("baRows").querySelectorAll(".rowlink"), function (tr) {
        tr.addEventListener("click", function () { openSub(tr.getAttribute("data-id")); });
      });
    });
  }

  // ── website messages ──
  function loadMessages() {
    api("/admin/api/messages").then(function (j) {
      if (j.mailConfigured === false) {
        $("baMailWarn").textContent = "⚠ Email sending isn't configured (RESEND_API_KEY not set in Railway), so form messages are only stored here — check this list regularly.";
        $("baMailWarn").hidden = false;
      } else if (j.notifyTo) {
        $("baMailWarn").textContent = "";
        $("baMailWarn").hidden = true;
      }
      var rows = (j.messages || []).map(function (m) {
        return "<tr><td><b>" + esc(m.id) + "</b></td><td>" + dt(m.createdAt) + "</td>" +
          "<td>" + esc(m.name) + '<div class="mute">' +
            '<a href="mailto:' + esc(m.email) + '" style="color:var(--gold)">' + esc(m.email) + "</a>" +
            (m.phone ? "<br>" + esc(m.phone) : "") + "</div></td>" +
          "<td>" + esc(m.topic || "") + "</td>" +
          '<td style="max-width:380px;white-space:pre-wrap">' + esc(m.message) + "</td></tr>";
      }).join("");
      $("baMsgs").innerHTML = rows || '<tr><td colspan="5" class="mute">No messages yet.</td></tr>';
    }).catch(function () {});
  }

  // ── detail ──
  function eff(s, i) { return i.adminOffer != null ? i.adminOffer : (s.payout === "credit" ? i.credit : i.cash); }
  function openSub(id) {
    api("/admin/api/submissions/" + id).then(function (s) {
      CUR = s;
      var items = s.items.map(function (i, idx) {
        return '<tr class="itemrow">' +
          "<td>" + (i.tcgplayerId ? '<img class="thumb" src="https://tcgplayer-cdn.tcgplayer.com/product/' + esc(i.tcgplayerId) + '_in_200x200.jpg" onerror="this.style.display=\'none\'">' : "") + "</td>" +
          "<td><b>" + esc(i.name) + '</b><div class="mute">' + esc([i.set, i.number].filter(Boolean).join(" · ")) +
            (i.graded ? " · <b>" + esc(i.gradeCompany || "GRADED") + " " + esc(i.grade || "") + "</b>" : "") + "</div>" +
            (i.photos || []).concat(i.photo ? [i.photo] : []).map(function (ph) {
              return '<img class="photo" src="' + ph + '">';
            }).join("") + "</td>" +
          "<td>" + esc(i.graded ? "Slab" : i.condition || "") +
            (i.printing && !/normal/i.test(i.printing) ? " · " + esc(i.printing) : "") +
            (i.scanCondition ? '<div class="mute" style="font-size:.72rem">scan: ' + esc(i.scanCondition) +
              (i.scanConfidence ? " (" + esc(i.scanConfidence) + ")" : "") +
              (i.conditionOverride ? ' <b class="warn">overridden</b>' : "") + "</div>" : "") +
            (i.scanReasons && i.scanReasons.length ? '<div class="mute" style="font-size:.7rem">' + esc(i.scanReasons.join(", ")) + "</div>" : "") +
            (i.note ? '<div style="font-size:.72rem;color:#8ee3ff">note: ' + esc(i.note) + "</div>" : "") + "</td>" +
          '<td class="right">' + fmt(i.market) + "</td>" +
          '<td class="right">' + (i.needsReview && i.adminOffer == null ? '<span class="warn">review</span>' : fmt(eff(s, i))) + "</td>" +
          '<td class="right"><input class="adj" type="number" step="0.01" min="0" id="adj_' + idx + '" value="' +
            (i.adminOffer != null ? i.adminOffer : "") + '" placeholder="' + (eff(s, i) != null ? eff(s, i) : "") + '"></td></tr>';
      }).join("");
      $("baDetail").hidden = false;
      $("baDetail").innerHTML =
        '<h2 class="panel-h">' + esc(s.id) + " — " + esc(s.contact.name) +
        ' <span class="badge b-' + esc(s.status) + '">' + esc(s.status) + "</span></h2>" +
        '<p class="mute">' + esc(s.contact.email) + " · " + esc(s.contact.phone || "") + " · " + dt(s.createdAt) +
        " · payout <b>" + esc(s.payout) + "</b> (" + s.pcts.cashPct + "% / " + s.pcts.creditPct + "%)</p>" +
        '<div class="ba-tablewrap"><table class="itemtable"><thead><tr><th></th><th>Card</th><th>Cond.</th>' +
        '<th class="right">Market</th><th class="right">Offer</th><th class="right">Your price</th></tr></thead><tbody>' +
        items + "</tbody></table></div>" +
        '<p class="right"><b>Estimated: ' + fmt(s.totals[s.payout]) +
        (s.totals.final != null ? " · Final: " + fmt(s.totals.final) : "") + "</b></p>" +
        '<div class="ba-actions"><input id="baNote" placeholder="Note (optional)">' +
        '<button class="btn" id="aRecv" type="button">Mark received</button>' +
        '<button class="btn gold" id="aAppr" type="button">Approve</button>' +
        '<button class="btn" id="aDecl" type="button">Decline</button>' +
        '<button class="btn gold" id="aPaid" type="button">Mark paid</button>' +
        '<button class="btn" id="aPrint" type="button">Print receipt</button></div>';
      $("aRecv").addEventListener("click", function () { act("received"); });
      $("aAppr").addEventListener("click", function () { act("approved"); });
      $("aDecl").addEventListener("click", function () { act("declined"); });
      $("aPaid").addEventListener("click", function () { act("paid"); });
      $("aPrint").addEventListener("click", printReceipt);
      $("baDetail").scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  }
  function act(status) {
    var adjust = CUR.items.map(function (i, idx) {
      return { index: idx, offer: $("adj_" + idx).value };
    }).filter(function (a) { return a.offer !== ""; });
    api("/admin/api/submissions/" + CUR.id, {
      method: "POST",
      body: JSON.stringify({ status: status, note: $("baNote").value, adjust: adjust }),
    }).then(function () { loadList(); openSub(CUR.id); });
  }
  function printReceipt() {
    var s = CUR;
    var rows = s.items.map(function (i) {
      return "<tr><td>" + esc(i.name) + (i.set ? " — " + esc(i.set) : "") + "</td><td>" +
        esc(i.graded ? (i.gradeCompany || "Graded") + " " + (i.grade || "") : i.condition) +
        "</td><td>" + fmt(eff(s, i)) + "</td></tr>";
    }).join("");
    var area = document.getElementById("tscPrint");
    area.innerHTML = "<h2>TCG Supply Co — Buylist receipt</h2>" +
      "<p>" + esc(s.id) + " · " + dt(s.createdAt) + " · " + esc(s.contact.name) + " (" + esc(s.contact.email) + ")</p>" +
      "<table><tr><th>Card</th><th>Condition</th><th>Offer</th></tr>" + rows + "</table>" +
      "<h3 style='text-align:right'>Total (" + esc(s.payout) + "): " +
      fmt(s.totals.final != null ? s.totals.final : s.totals[s.payout]) + "</h3>" +
      "<p style='font-size:12px'>TCG Supply Co · 1871 Wells Rd, Suite 17 · Orange Park, FL 32073 · 324-200-8945</p>";
    area.hidden = false;
    window.print();
  }
  window.addEventListener("afterprint", function () {
    var a = document.getElementById("tscPrint"); if (a) a.hidden = true;
  });

  var app = document.getElementById("baApp");
  if (app && app.getAttribute("data-gate") === "closed") return;   // tag check not satisfied

  function autoSignIn(key) {
    $("baLogin").hidden = true;
    return api("/admin/api/login", { method: "POST", body: JSON.stringify({ password: key }) })
      .then(function (j) {
        if (!j || !j.token) throw new Error(j && j.error ? j.error : "auto sign-in failed");
        TOKEN = j.token;
        sessionStorage.setItem("tsc_admin_token", TOKEN);
        localStorage.setItem("tsc_staff_token", TOKEN);
        boot(j.persistent);
      })
      .catch(function () {
        $("baLogin").hidden = false;
        $("baLoginMsg").textContent = "Automatic sign-in didn't work — enter the password.";
      });
  }

  if (TOKEN) { boot(); }
  else {
    var key = app && app.getAttribute("data-key");
    if (key) autoSignIn(key);
  }
})();
